// @ts-nocheck
import { useState, useEffect } from 'react';
import axios from 'axios';
import { useSnackbar } from 'notistack';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { API_ENDPOINTS } from '../const/ApiEndpoints';
import { selectAuth } from '../state/slices/appSlice';
import { CoreUtils } from '../utils/Utils';
import constants from '../const/Const';
/**
 * @function useAssignSearches
 * @description a custom hook which handles APIs related to Assign Searches
 * @returns {object} object
 */
const useAssignSearches = () => {
  const { user } = useSelector(selectAuth);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [initiatedData, setInitiatedData] = useState([]);
  const [teamList, setTeamList] = useState([]);
  const [selectData, setSelectData] = useState([]);
  const [stepsWiseFormData, setStepWiseFormData] = useState({});

  /**
   * @function fetchTeamData
   * @description A function to fetch team data
   * @returns {Promise} returns an axios promise
   */
  const fetchTeamData = (queryParams) => {
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.INITIATE_SCREEN_TEAM_DATA, {
        params: queryParams,
      })
      .then(
        (response) => {
          setIsLoading(false);
          setTeamList(response?.data);
        },
        (e) => {
          setIsLoading(false);
          setIsError(e);
        }
      );
  };
  useEffect(() => {
    fetchTeamData({
      assign_search: true,
    });
  }, []);
  /**
   * @function fetchSearchData
   * @description A function to fetch searched information
   * @param {object} data
   * @returns {Promise} returns an axios promise
   */
  const fetchSearchData = (data) => {
    setIsLoading(true);
    return axios
      .get(API_ENDPOINTS.INITIATE_SCREEN_MANUAL_ASSIGN, {
        params: {
          ...data,
        },
      })
      .then(
        (response) => {
          setIsLoading(false);
          setInitiatedData(response?.data);
          return response;
        },
        (e) => {
          setIsLoading(false);
          setIsError(e);
        }
      );
  };
  const fetchSearchTableData = ({ page = 0, pageSize = 5, filters }) => {
    const modifiedFilters = CoreUtils.buildModifiedFilters(filters);
    const params = {
      page: page + 1,
      page_size: pageSize,
      searchFor: modifiedFilters?.searchFor ?? '',
      start_date: modifiedFilters?.assignSearchDateRange?.start
        ? moment(modifiedFilters?.assignSearchDateRange?.start).format(
            constants.GLOBAL_DATE_FORMAT
          )
        : '',
      end_date: modifiedFilters?.assignSearchDateRange?.end
        ? moment(modifiedFilters?.assignSearchDateRange?.end).format(
            constants.GLOBAL_DATE_FORMAT
          )
        : '',
      search_key: modifiedFilters?.search ?? '',
      assignType: modifiedFilters?.assignType ?? 'new',
      screeningType: modifiedFilters?.screeningType ?? '',
      searchType: modifiedFilters?.searchType ?? '',
      alerts: modifiedFilters?.alerts ?? '',
      batchId: modifiedFilters?.batchId ?? '',
      team: modifiedFilters?.team ?? '',
      manager_id: modifiedFilters?.manager_id ?? '',
      analyst_id: modifiedFilters?.analyst_id ?? '',
      ...(modifiedFilters?.module === 'transaction_screening' && {
        transaction_screening: true,
      }),
    };
    return axios
      .get(API_ENDPOINTS.INITIATE_SCREEN_MANUAL_ASSIGN, {
        params,
        loader: false,
      })
      .then((res) => {
        return {
          data: res?.data,
          totalRowCount: res.headers?.['x-total-count'],
        };
      });
  };

  const assignSearches = (data) => {
    // eslint-disable-next-line no-shadow
    const { selectData, selectedTeams, filters, transaction_screening } = data;
    // eslint-disable-next-line no-shadow
    const searchId = selectData?.map((data) => data.search_id);
    const internalTransactionId = selectData?.map((data) =>
      data?.internal_transaction_id ? data?.internal_transaction_id : []
    );
    // eslint-disable-next-line no-shadow
    const batchId = selectData?.map((data) =>
      data.batch_id ? data.batch_id : []
    );
    const body = {
      searchFor: filters?.searchFor,
      assignType: filters?.assignType ?? 'new',
      screeningType: filters?.screeningType,
      searchType: filters?.searchType,
      team: filters?.team,
      analyst_id: filters?.analyst_id,
      manager_id: filters?.manager_id,
      alerts: filters?.alerts,
      batchId: filters?.batchId ?? '',
      startDate: filters.startDate,
      endDate: filters.endDate,
      selectedTeams,
      selectedSearches:
        internalTransactionId[0]?.length !== 0
          ? internalTransactionId
          : batchId[0]?.length === 0
          ? searchId
          : batchId,
      transaction_screening,
    };
    setIsLoading(true);
    return axios.post(API_ENDPOINTS.INITIATE_SCREEN_MANUAL_ASSIGN, body).then(
      () => {
        setIsLoading(false);
        enqueueSnackbar('Assign searches successfully', {
          variant: 'success',
        });
      },
      (e) => {
        setIsLoading(false);
        setIsError(e);
      }
    );
  };

  const manualAssignSearches = (data) => {
    const {
      selectData: selectedDataReceived,
      values,
      analyst_id: analystId,
      manager_id: managerId,
    } = data;
    const searchId = selectedDataReceived?.map((d) => d.original.search_id);
    const batchId = selectedDataReceived?.map((d) =>
      d.original.batch_id ? d.original.batch_id : []
    );
    const body = {
      screening_type: values.screeningType?.[0],
      search_id: batchId[0]?.length === 0 ? searchId : batchId,
      target_user_id: analystId,
      manager_id: managerId,
    };
    setIsLoading(true);
    return axios
      .post(API_ENDPOINTS.INITIATE_SCREEN_MANUAL_ASSIGN_SEARCHES, body)
      .then(
        () => {
          setIsLoading(false);
          enqueueSnackbar('Assign searches successfully', {
            variant: 'success',
          });
          setTimeout(() => {
            fetchSearchData(values);
          }, 800);
        },
        (e) => {
          setIsLoading(false);
          setIsError(e);
        }
      );
  };
  return {
    user,
    isError,
    isLoading,
    fetchSearchData,
    fetchSearchTableData,
    teamList,
    initiatedData,
    selectData,
    setSelectData,
    setInitiatedData,
    assignSearches,
    manualAssignSearches,
    stepsWiseFormData,
    setStepWiseFormData,
  };
};

export default useAssignSearches;
